module.exports = __webpack_public_path__ + "static/RampDefi-bd56330b22b025d19846c89ae2fb64f9.png";